import { FeatureList, Modal } from '@circlefin/components'
import { TransWithLink } from '@shared/components/common'
import useTranslation from 'next-translate/useTranslation'

export interface FundAccountForBurnFeeProps {
  /**
   * Open modal.
   */
  open?: boolean
  /**
   * Callback called after the modal has closed itself.
   */
  onCloseEnd?: () => void
}

export const FundAccountForBurnFee: React.FC<FundAccountForBurnFeeProps> = ({
  open,
  onCloseEnd,
}) => {
  const { t } = useTranslation('custody/common')

  return (
    <Modal onCloseEnd={onCloseEnd} open={open} size="md">
      <Modal.Header
        iconName="ArchiveOutline"
        title={t('fundAccountForBurnFee.fundYourAccountTitle')}
        variant="info"
      />
      <Modal.Body className="p-8">
        {t('fundAccountForBurnFee.bodyNetStandardFees')}

        <FeatureList className="mt-8">
          <FeatureList.Item
            heading={t('fundAccountForBurnFee.titleOnChain')}
            icon="LinkOutline"
          >
            <p className="text-neutral-subtle type-body-sm">
              <TransWithLink
                i18nKey="custody/common:fundAccountForBurnFee.bodyOnChain"
                urlI18nKey="custody/common:fundAccountForBurnFee.fundOnChainUrl"
                variant="url"
              />
            </p>
          </FeatureList.Item>
          <FeatureList.Item
            heading={t('fundAccountForBurnFee.titleWithFiat')}
            icon="LibraryOutline"
          >
            <p className="text-neutral-subtle type-body-sm">
              <TransWithLink
                i18nKey="custody/common:fundAccountForBurnFee.bodyWithFiat"
                urlI18nKey="custody/common:fundAccountForBurnFee.fundWithFiatUrl"
                variant="url"
              />
            </p>
          </FeatureList.Item>
        </FeatureList>
      </Modal.Body>
    </Modal>
  )
}
